import React from 'react'
import styled from 'styled-components'
import { colors } from '../../healtheraComponents'
import IconDownload from '../Icons/IconDownload'
import DataGroup from '../Shared/DataGroup'
import Badge from '../Badge/Badge'
import capitalize from '../../utils/capitalize'

const PatientData = ({
  patientData: { gender, birthDate, nhs, mobileNumber, email, patientAddress, deliveryAddress, nominatedSurgeryAddress, downloadNominationPDF },
}) => (
  <PatientDataWrapper>
    <DataGroupWrapper>
      <DataGroup
        title="Patient Details"
        rows={[
          { key: 1, label: 'Gender', value: gender },
          { key: 2, label: 'DOB', value: birthDate },
          { key: 3, label: 'NHS', value: nhs },
          { key: 4, label: 'Mobile', value: mobileNumber },
          { key: 5, label: 'Email', value: email }
        ]}
      />
    </DataGroupWrapper>
    {patientAddress && (
      <DataGroupWrapper>
        <DataGroup
          title="Address"
          rows={[
            { key: 1, value: patientAddress.line1 },
            { key: 2, value: patientAddress.postcode }
          ]}
        />
      </DataGroupWrapper>
    )}
    {deliveryAddress && (
      <DataGroupWrapper>
        <DataGroup
          title="Delivery Address"
          rows={[
            { key: 1, value: deliveryAddress.line1 },
            { key: 2, value: deliveryAddress.city },
            { key: 3, value: deliveryAddress.postcode }
          ]}
        />
      </DataGroupWrapper>
    )}
    {nominatedSurgeryAddress && (
      <DataGroupWrapper>
        <DataGroup
          title="Nominated Surgery"
          rows={[
            { key: 1, value: nominatedSurgeryAddress.line1 },
            { key: 2, value: nominatedSurgeryAddress.line2 },
            { key: 3, value: nominatedSurgeryAddress.line3 },
            { key: 4, value: nominatedSurgeryAddress.line4 },
            { key: 5, value: nominatedSurgeryAddress.line5 },
            { key: 6, value: nominatedSurgeryAddress.postcode },
          ]}
        />
        {nominatedSurgeryAddress.integration_method && <Badge text={`${capitalize(nominatedSurgeryAddress.integration_method)} Integrated`} green right />}
      </DataGroupWrapper>
    )}

    <Download onClick={downloadNominationPDF}>
      Download Nomination Form
      <IconDownloadStyled />
    </Download>
  </PatientDataWrapper>
)

export default PatientData

export const DataGroupWrapper = styled.div`
  border-bottom: 1px solid ${colors.GRAY_LIGHT};
  margin-bottom: 14px;
  padding-bottom: 14px;
`

export const PatientDataWrapper = styled.div`
  flex: 0 0 230px;
  margin-right: 20px;
  margin-top: 5px;
`

export const Download = styled.div`
  align-items: center;
  color: ${colors.HEALTHERA_GREEN};
  display: flex;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  width: fit-content;
  cursor: pointer;
`

export const IconDownloadStyled = styled(IconDownload)`
  fill: currentColor;
  margin-left: 5px;
  width: 24px;
`
